import axios from '@/services/axios'

export default {
    getallpropbyperiod(st_dt, en_dt, ctgSq, source) {
        return axios.get(`/tracking/getallpropbyperiod/${st_dt}&${en_dt}&${ctgSq}`, { cancelToken: source.token });
    },

    getPropDetail(search, source) {
        return axios.post(`/tracking/getpropdetail`, search, { cancelToken: source.token });
    },

    getTrackingInfo(search, source) {
        return axios.post(`/tracking/gettrackinginfo`, search, { cancelToken: source.token });
    },

    getHighDiffKeywords(search, source) {
        return axios.post(`/tracking/getHighDiffKeywords`, search, { cancelToken: source.token });
    },
};